<script src="../../../../../../../Downloads/api.js"></script>
<template>
  <b-modal id="CouponUseDetail" size="lg" ref="CouponUseDetail" title="사용내역조회">
    <b-row class="text-center">
      <b-col cols="2"></b-col>
      <b-col cols="8">
        <b-table
        :fields ="fields"
        head-variant="light"
        ref="general-table"
        class="vuetable"
        id="table-transition-example"
        :items="data"
        responsive=""
        align="center"
        >
        </b-table>
      </b-col>
      <b-col cols="2"></b-col>
    </b-row>

    <template slot="modal-footer">
      <b-button variant="outline-primary" @click="ModalHide">닫기</b-button>
    </template>
  </b-modal>
</template>
<script>
  import {currencyFilter ,alignTableCenter} from "../../../utils";

  export default {
    name : "CouponUseDetail" ,
    props : ['data'] ,
    filters : {...currencyFilter},
    data() {
      return {
        fields:[
          {key :'use_date' , label : '사용일자' ,...alignTableCenter} ,
          {key :'use_store' , label : '사용매장' ,...alignTableCenter} ,
          {key :'use_history' , label : '처리내용',...alignTableCenter} ,
        ]
      }
    },
    mounted() {

    },
    watch : {
    },
    methods: {
      open(){
        this.$refs['CouponUseDetail'].show()
      },
      ModalHide(){
        this.$refs['CouponUseDetail'].hide()
      }
    }
  }
</script>
